// extracted by mini-css-extract-plugin
export default {"root":"CheckboxField_root__rwzwP","label":"CheckboxField_label__TiQa-"};